module.exports = function() {
  return new Worker(__webpack_public_path__ + "0d47a94c81fb1885573d.worker.js");
};